module.exports = __webpack_public_path__ + "img/home-2.9a084b4a.webp";